import axios, { AxiosError, AxiosResponse } from 'libs/axios';
import { useMutation, useQuery } from 'react-query';
import { PartialTimelineConnectionDetails } from 'types/timeline-connection';
import {
    OBFUSCATION_ENABLED_QUERY_KEY,
    TIMELINE_CONNECTION_QUERY_KEY,
    DISCLOSE_OPERATOR_ENABLED_QUERY_KEY,
    EXPORT_OPERATOR_ENABLED_QUERY_KEY,
    EXPORT_HOST_ENABLED_QUERY_KEY
} from './query-keys';

export const useTimelineConnection = () => {
    return useQuery<PartialTimelineConnectionDetails, AxiosError>(
        TIMELINE_CONNECTION_QUERY_KEY,
        async () => {
            const response = await axios.get<PartialTimelineConnectionDetails>(
                `/api/ui/settings/timeline`
            );

            return response.data;
        },
        { refetchOnWindowFocus: false }
    );
};

export const useEditTimelineConnection = () => {
    return useMutation<
        AxiosResponse,
        AxiosError,
        PartialTimelineConnectionDetails
    >(async (data) => {
        return axios.post(`/api/ui/settings/timeline`, data);
    });
};

export const useObfuscationEnabled = () => {
    return useQuery<boolean, AxiosError>(
        OBFUSCATION_ENABLED_QUERY_KEY,
        async () => {
            const response = await axios.get<boolean>(
                `/api/ui/settings/obfuscate`
            );

            return response.data;
        },
        { refetchOnWindowFocus: false }
    );
};

export const useEditObfuscationEnabled = () => {
    return useMutation<AxiosResponse, AxiosError, boolean>(async (data) => {
        return axios.post(`/api/ui/settings/obfuscate`, null, {
            params: { value: data }
        });
    });
};

export const useDiscloseOperatorEnabled = () => {
    return useQuery<boolean, AxiosError>(
        DISCLOSE_OPERATOR_ENABLED_QUERY_KEY,
        async () => {
            const response = await axios.get<boolean>(
                `/api/ui/settings/discloseOperatorNames`
            );

            return response.data;
        },
        { refetchOnWindowFocus: false }
    );
};

export const useEditDiscloseOperatorEnabled = () => {
    return useMutation<AxiosResponse, AxiosError, boolean>(async (data) => {
        return axios.post(`/api/ui/settings/discloseOperatorNames`, null, {
            params: { value: data }
        });
    });
};

export const useExportOperatorEnabled = () => {
    return useQuery<boolean, AxiosError>(
        EXPORT_OPERATOR_ENABLED_QUERY_KEY,
        async () => {
            const response = await axios.get<boolean>(
                `/api/ui/settings/exportOperatorNames`
            );

            return response.data;
        },
        { refetchOnWindowFocus: false }
    );
};

export const useEditExportOperatorEnabled = () => {
    return useMutation<AxiosResponse, AxiosError, boolean>(async (data) => {
        return axios.post(`/api/ui/settings/exportOperatorNames`, null, {
            params: { value: data }
        });
    });
};

export const useExportHostEnabled = () => {
    return useQuery<boolean, AxiosError>(
        EXPORT_HOST_ENABLED_QUERY_KEY,
        async () => {
            const response = await axios.get<boolean>(
                `/api/ui/settings/exportHostNames`
            );

            return response.data;
        },
        { refetchOnWindowFocus: false }
    );
};

export const useEditExportHostEnabled = () => {
    return useMutation<AxiosResponse, AxiosError, boolean>(async (data) => {
        return axios.post(`/api/ui/settings/exportHostNames`, null, {
            params: { value: data }
        });
    });
};
